namespace Areas.WebsiteInfo.Planning {
    "use strict";

    let planningId: number;


    const baseUrl = "/WebsiteInfo/Planning";


    export function onGridSelectionChanged(e: any) {
        var rowData: any = e.selectedRowsData[0];

        var rowForm: any = $("#PlanningForm").dxForm("instance");
        rowForm.option("formData", rowData);

        let selectedRows = e.component.getSelectedRowsData();
        planningId = selectedRows[0].websitePlanningId;
    }

    export function onPlanningContentReady(e: any) {
        if (!e.component.getSelectedRowKeys().length)
            e.component.selectRowsByIndexes(0);
    }

    export function addPlanning() {
        const form = $("#PlanningForm").dxForm("instance");
        planningId = 0;

        $.get(`${baseUrl}/AddPlanning/${planningId}`,
            (data) => {
                form.option("formData", data);
            });

    }

    export function updatePlanning() {
        const form = $("#PlanningForm").dxForm("instance");
        const newData: any = form.option("formData");

        if (newData.websitePlanningId == 0) {
            saveRecord(newData);
        } else {
            updateRecord(newData)
        }
    }

    function saveRecord(newData: any) {
        const url = `${baseUrl}/PlanningPost`;
        const method = "POST";

        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage();
            });
    }

    function updateRecord(newData: any) {
        const url = `${baseUrl}/PlanningPut/${planningId}`;
        const method = "PUT";

        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage();
            });
    }

    function accountDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#PlanningForm").dxForm("instance");
            const formData: any = form.option("formData");

            formData.accountId = data.accountId;
            formData.projectName = data.projectName;
            formData.projectNumber = data.projectNumber;
            formData.projectCCNumber = data.projectCCNumber;

            form.option("formData", formData);
        }
    }

    export function selectAccount() {
        const form: any = $("#PlanningForm").dxForm("instance");

        const accountLookupDialog =
            new Areas.Dialogs.AccountDialog(accountDialogClosing());
    }
}